module.exports = __webpack_public_path__ + "img/element_2.1afaca41.png";